import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Button } from '../design/components'
import { useAuth } from './AuthProvider'
import { displayNameOf, isAdmin } from './types'
import styles from './UserMenu.module.css'

/** Account summary and sign-out, in the app shell's header slot. */
export function UserMenu() {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState(false)

  if (user === null) return null

  const name = displayNameOf(user)

  async function onSignOut() {
    setBusy(true)
    await signOut()
    setOpen(false)
    setBusy(false)
    void navigate('/login', { replace: true })
  }

  return (
    <div className={styles.wrap}>
      <button
        type="button"
        className={styles.trigger}
        aria-expanded={open}
        aria-haspopup="dialog"
        onClick={() => setOpen((value) => !value)}
      >
        <span className={styles.avatar} aria-hidden="true">
          {name.slice(0, 1).toUpperCase()}
        </span>
        <span className="sr-only">Account: {name}</span>
      </button>

      {open && (
        <>
          <div className={styles.scrim} onClick={() => setOpen(false)} aria-hidden="true" />
          <div className={styles.panel} role="dialog" aria-label="Account">
            <p className={styles.name}>{name}</p>
            {user.email !== null && <p className={styles.email}>{user.email}</p>}
            {isAdmin(user) && <span className={styles.role}>Admin</span>}

            <p className={styles.warning}>
              Signing out invalidates this account&rsquo;s sessions on <strong>every device</strong>
              , not just this one.
            </p>

            <Button variant="secondary" fullWidth disabled={busy} onClick={() => void onSignOut()}>
              {busy ? 'Signing out…' : 'Sign out'}
            </Button>
          </div>
        </>
      )}
    </div>
  )
}
